import React from 'react';
import { browserHistory } from 'react-router';
import Row from 'react-bootstrap/lib/Row';
import { useRedux } from 'use-redux';
import { lifecycle } from 'recompose';
import { Translate } from 'react-redux-i18n';

import FreeCard from './Cards/FreeCard';
import TeacherCard from './Cards/TeacherCard';
import { addMarketingFlags } from '../../actions/utils';
import { Footer } from './Footer';

import './Shop.jsx.scss';

const updateMarketingFlags = lifecycle({
  componentWillMount() {
    const {
      params: { flag },
    } = this.props;
    if (flag) {
      addMarketingFlags([flag]);
      browserHistory.replace('/i/plan');
    }
  },
});

const SelectPlan = () => {
  const [
    {
      auth: { user },
    },
  ] = useRedux();

  return (
    <div className="container-fluid new-style select-plan code-gray-bg">
      <div className="container">
        <h2 className="title">
          <div className="quote" />
          <Translate value="shop.tariffs" />
        </h2>

        <Row className="cards-row">
          <TeacherCard user={user} />
          <FreeCard />
        </Row>

        <Footer />
      </div>
    </div>
  );
};

export default updateMarketingFlags(SelectPlan);
